export default "__VITE_ASSET__BhOYv2r1__"